import { home } from "./en/home";
import { maijia } from "./en/maijia";

export default {
	home,
	maijia
};
